import type { PncStat } from '@/types/people-and-culture';

export function formatPncStatValue(stat: PncStat | null | undefined): string {
  if (!stat) return '';
  return `${stat.statValue ?? ''}${stat.statSuffix ?? ''}`.trim();
}
